import { useI18n } from 'vue-i18n'
import { decodeNotificationText } from '@/modules/notifications/utils/notification-i18n.util'
import { useDateFormatToShow } from '@/shared/composables/forms/date-format-to-show.composable'
import { useDayJs } from '@/shared/composables/use-dayjs'

const ISO_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/

export function useNotificationContent() {
  const { t, te } = useI18n()
  const dayJs = useDayJs()
  const dateFormat = useDateFormatToShow()

  function localize(values = {}) {
    return Object.fromEntries(
      Object.entries(values).map(([key, value]) => [
        key,
        typeof value === 'string' && ISO_DATE_TIME.test(value)
          ? dayJs.formatDateUtc(value, dateFormat.value)
          : value,
      ]),
    )
  }

  function resolve(key, literal, values) {
    const embedded = decodeNotificationText(literal)
    const resolvedKey = key || embedded?.key
    const resolvedValues = values ?? embedded?.params

    if (!resolvedKey || !(te(resolvedKey) || te(resolvedKey, 'en'))) {
      return embedded ? embedded.key : literal
    }

    return t(resolvedKey, localize(resolvedValues))
  }

  const resolveTitle = notification =>
    resolve(notification?.titleKey, notification?.title, notification?.params)

  const resolveContent = notification =>
    resolve(notification?.contentKey, notification?.content, notification?.params)

  return { resolveTitle, resolveContent }
}
